<div class="alert-config-grid-expander">
    <div class="alert-config-grid-expander__container-label">
        <p>{{ globalL10nKeys.typeLabel | vtranslate }}</p>
        <hr>
        <p>{{ typeLabel ?? (globalL10nKeys.notApplicableLabel | vtranslate) }}</p>
    </div>
    <div class="alert-config-grid-expander__container">
        <div>
            <span>{{ (isEvents ? l10nKeys.columnTitleEvents : l10nKeys.columnTitleMetrics) | vtranslate }}</span>
        </div>
        <hr>
        <div class="alert-config-grid-expander__grid-events-list">
            {{ constructEventsString() }}
        </div>
    </div>
</div>
